import { Control, Controller } from 'react-hook-form';

import { CurrencyTextInput } from '@/components/form-controls';
import { OverridableCompendiumValue } from '@/types/overridable-compendium-value';
import { formatCurrency } from '@/utils/formatting';

type WacPriceCellProps = {
  ndc: string,
  wac?: OverridableCompendiumValue
  isOverriding: boolean,
  control: Control<any>,
};

export const WacPriceCell = ({ ndc, wac, isOverriding, control }: WacPriceCellProps) => {
  const formKey = `${ndc}.wac`;

  return (
    <div className="min-w-32">
      {isOverriding
        && <Controller
          control={control}
          name={formKey}
          render={({ field: { value, onChange, onBlur } }) => (
            <CurrencyTextInput
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              id={formKey}
              name={formKey}
            />
          )}
        />
      }

      {!isOverriding && wac?.overrideValue != null
        && <span>{formatCurrency(wac.overrideValue)}</span>
      }

      {!isOverriding && wac?.overrideValue == null && wac?.compendiumValue != null
        && <span>{formatCurrency(wac.compendiumValue)}</span>
      }

      {!isOverriding && wac?.overrideValue == null && wac?.compendiumValue == null
        && <span>&mdash;</span>
      }
    </div>
  );
};
